import React from "react";
import { motion } from "framer-motion";
import { FiMonitor, FiLayers, FiSmartphone, FiCpu } from "react-icons/fi";

const container = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
      when: "beforeChildren",
      staggerChildren: 0.12,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30, scale: 0.98 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
};

const services = [
  {
    icon: <FiMonitor />,
    title: "Front-End",
    tagline: "Pixel-perfect React UIs",
    gradient: "from-sky-400 to-blue-500",
  },
  {
    icon: <FiLayers />,
    title: "Full-Stack",
    tagline: "Scalable MERN & Next.js apps",
    gradient: "from-indigo-500 to-violet-500",
  },
  {
    icon: <FiSmartphone />,
    title: "Mobile Apps",
    tagline: "Cross-platform, native feel",
    gradient: "from-cyan-400 to-teal-500",
  },
  {
    icon: <FiCpu />,
    title: "AI Agents",
    tagline: "Custom agents & automation",
    gradient: "from-orange-500 to-rose-500",
  },
];

const Services = () => {
  return (
    <section id="services" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.3 }}
          className="flex flex-col items-center lg:items-start justify-center lg:justify-between mb-8 sm:mb-10 text-center lg:text-left"
        >
          <motion.div variants={item} className="space-y-2">
            <p className="text-sm font-medium text-gray-500 flex items-center justify-center lg:justify-start gap-2">
              <span
                className="inline-block h-1.5 w-1.5 rounded-full"
                style={{ backgroundColor: "rgb(232, 51, 16)" }}
              />
              Specialization
            </p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold tracking-tight leading-tight">
              <span style={{ color: "rgb(232, 51, 16)" }}>Services</span>{" "}
              <span className="text-gray-900">I Provide</span>
            </h2>
          </motion.div>
        </motion.div>

        {/* Cards */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
          className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5"
        >
          {services.map((s, i) => (
            <motion.div
              key={i}
              variants={item}
              whileHover={{ y: -6 }}
              className="group relative overflow-hidden rounded-3xl border border-gray-200 bg-gray-50 p-5 sm:p-7 transition-all duration-300 hover:shadow-xl hover:shadow-gray-200/60"
            >
              {/* Large faint background icon as graphic */}
              <span className="pointer-events-none absolute -right-4 -bottom-4 text-8xl text-gray-900/[0.04] transition-transform duration-500 group-hover:scale-110">
                {s.icon}
              </span>

              {/* Gradient icon tile */}
              <div
                className={`inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-gradient-to-br ${s.gradient} text-white text-2xl sm:text-3xl shadow-lg`}
              >
                {s.icon}
              </div>

              <h3 className="mt-5 text-lg sm:text-xl font-bold text-gray-900">
                {s.title}
              </h3>
              <p className="mt-1 text-xs sm:text-sm text-gray-500">
                {s.tagline}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
